/** @format */

import {DuplicateOrderButton} from '../shared/duplicate_order_button';
import {IfElse} from 'frontier-utilities';
import React from 'react';

export const DuplicateOrder = props => {
    const {order} = props;
    return (
        <DuplicateOrderButton id={order.id}>
            <DuplicateOrderCustomButton />
        </DuplicateOrderButton>
    );
};

function DuplicateOrderCustomButton(props) {
    const {isPending, handleDuplicate} = props;
    return (
        <IfElse condition={!isPending}>
            <button
                className="d-flex align-items-center justify-content-center gap-2 color-accent-primary"
                onClick={handleDuplicate}>
                <i className="fas fa-copy" />
                <u>Duplicate</u>
            </button>
            <button
                disabled
                className="d-flex align-items-center justify-content-center gap-2 color-structure-darker">
                <i className="fas fa-spin fa-spinner" />
                <u>Duplicating</u>
            </button>
        </IfElse>
    );
}
